"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGoodFriday = exports.getLastDay = exports.getNthDay = exports.getDate = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const getDate = (param) => {
    const { year, month, day } = param;
    return dayjs_1.default(`${year}-${month}-${day !== null && day !== void 0 ? day : 1}`, "YYYY-MM-DD");
};
exports.getDate = getDate;
const getNthDay = (param) => {
    const { n, year, month, day } = param;
    let result = exports.getDate({ month, year }).day(day);
    if (result.month() !== month - 1) {
        result = result.add(1, "week");
    }
    result = result.add(n - 1, "week");
    return result;
};
exports.getNthDay = getNthDay;
const getLastDay = (param) => {
    const { year, month, day } = param;
    const daysInMonth = dayjs_1.default(exports.getDate({ month, year })).daysInMonth();
    const lastDayOfMonth = dayjs_1.default(`${year}-${month}-${daysInMonth}`, "YYYY-MM-DD");
    let result = lastDayOfMonth.day(day);
    if (result.month() !== month - 1) {
        result = result.subtract(1, "week");
    }
    return result;
};
exports.getLastDay = getLastDay;
const getEasterSunday = (param) => {
    const { year } = param;
    const f = Math.floor, G = year % 19, C = f(year / 100), H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30, I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)), J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7, L = I - J, month = 3 + f((L + 40) / 44), day = L + 28 - 31 * f(month / 4);
    return exports.getDate({ year, month, day });
};
const getGoodFriday = (param) => {
    const { year } = param;
    return getEasterSunday({ year }).subtract(2, "days");
};
exports.getGoodFriday = getGoodFriday;
